export const ONBOARD_CLIENT = "ONBOARD_CLIENT";
export const ONBOARD_RESELLER = "ONBOARD_RESELLER";
export const CURRENT_STEP = "CURRENT_STEP";
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const EDIT_COMMISSION = "EDIT_COMMISSION";
export const GLOBAL_FILTERS = "GLOBAL_FILTERS";

export const LISTING_DATA = "LISTING_DATA";

export const DROPDOWN_LISTING_DATA = "DROPDOWN_LISTING_DATA";

export const DAHBOARD_COUNTS = "DAHBOARD_COUNTS";

export const LOADER_SLICE = "LOADER_SLICE";

export const ACL_LIST = "ACL_LIST";

export const ADD_SERVICE = "ADD_SERVICE";
export const ESKAY = "ESKAY";
export const LOGO_SLICE = "LOGO_SLICE";
